module.exports = __webpack_public_path__ + "static/media/europe.f6c0c80e.webp";